import{styled as t}from"styled-components";const e=t.span`
  font-weight: bold;
  line-height: 1.8em;
  text-align: center;
`;export{e as YmLabel};
